<template>
    <div>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12">
                    <str-worker-autocomplete
                            v-model="filter.id"
                            label="Employé"
                    />
                </v-col>
                <v-col cols="12">
                    <w-enum-select
                        v-model="filter.phase"
                        :items="workerPhases"
                        :label="$t('worker.status')"
                    />
                </v-col>
                <v-col cols="12">
                    <organizational-chart-select
                            v-model="filter.organizationalchartIds"
                            :label="$t('module.organizational_charts')"
                    />
                </v-col>
                <v-col cols="12">
                    <str-occupation-autocomplete
                            v-model="filter.occupationId"
                            label="Fonction"
                    />
                </v-col>
                <v-col cols="12">
                    <w-data-select-autocomplete
                            v-model="filter.workplaceId"
                            label="Lieu de Travail"
                            type="WORKER_WORKPLACE"
                   />
                </v-col>
                <v-col cols="12">
                    <w-data-select-autocomplete
                            v-model="filter.companyId"
                            label="Société de déclaration"
                            type="WORKER_COMPANY"
                    />
                </v-col>
                <v-col cols="12">
                    <w-data-select-autocomplete
                            v-model="filter.stateId"
                            label="Etat"
                            type="WORKER_STATE"
                    />
                </v-col>
                <v-col cols="12">
                    <w-enum-select
                            v-model="filter.sex"
                            :items="sex"
                            label="Sexe"
                    />
                </v-col>
            </v-row>
        </v-container>

        <input type="hidden"/>
    </div>
</template>

<script>
import {ref, watch} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";

export default {
    name: "BlankPaySlipFilter",
    props: {
        value: Object,
    },
    setup(props, {emit}) {
        const {workerPhases,  sex} = useSharedSelectData();
        const filter = ref({
            phase: "ACTIVE"
        });


        watch(() => props.value, () => {
            filter.value = props.value;
        }, {immediate: true});

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});

        return {
            filter,
            workerPhases,
            sex,
        }
    }
}
</script>

<style scoped>

</style>